import { ThemeMode } from 'styles/GeckoTheme'

import { DesignSystemTheme } from './DesignSystemThemeProvider'

export function getDesignSystemThemeForGeckoMode(
  themeMode: ThemeMode
): DesignSystemTheme {
  if (themeMode === ThemeMode.Light) {
    return DesignSystemTheme.Light
  }

  if (themeMode === ThemeMode.Zinc) {
    return DesignSystemTheme.Zinc
  }

  return DesignSystemTheme.Dark
}
